var _desc, _path, _line, _line2, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHappyFace(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: "48px",
    height: "48px",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId,
    stroke: "#2329D6",
    strokeWidth: 1,
    strokeLinecap: "square",
    strokeLinejoin: "miter",
    fill: "none",
    color: "#2329D6",
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "happyFaceIconTitle"
  }, "Happy Face") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "happyFaceIconTitle"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "happyFaceIconDesc"
  }, "Icon of a face with a smile")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.3010863,14.0011479 C8.0734404,15.7578367 9.98813711,17 11.9995889,17 C14.0024928,17 15.913479,15.7546194 16.6925307,14.0055328"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    strokeLinecap: "round",
    x1: 9,
    y1: 9,
    x2: 9,
    y2: 9
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    strokeLinecap: "round",
    x1: 15,
    y1: 9,
    x2: 15,
    y2: 9
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHappyFace);
export default __webpack_public_path__ + "static/media/happy-face.f3558c71bb1d09be813ac5e61a8255f6.svg";
export { ForwardRef as ReactComponent };